import Index from './Index.vue';

export default {
  path: 'composicoes',
  name: 'produto-composicao',
  component: Index,
};
